import React, { memo } from 'react';
import TemplateDetail from '../enrich-template-detail-step';

const EnrichExistingColumnStep: React.FC = memo((props) => (
  <TemplateDetail enrichProspect={false} {...props} />
));

export default EnrichExistingColumnStep;
